import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';
import { QueryUtils } from 'app/core/utils/query.utils';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private http = inject(HttpClient);
  private url = Global.url + 'V1/payments';

  constructor() { }

  create(payment: any): Observable<any> {
    return this.http.post(this.url, payment);
  }

  getAccountAnalysis(filters: any): Observable<any[]> {
    // Usamos QueryUtils para estandarizar el envío de parámetros (ej. multiselección de entidades)
    const params = QueryUtils.convertToFilter(filters);
    const path = `range-period/${filters.periodStartId}/${filters.periodEndId}`;
    
    return this.http.get<any[]>(`${this.url}/analysis/${path}`, { params });
  }

  reconcile(entityCode: number): Observable<any> {
    return this.http.post(`${this.url}/reconcile`, { entityCode });
  }

  // Marca pagos de entidades como contabilizados
  markAccounted(uuids: string[]): Observable<any> {
    return this.http.put(`${this.url}/mark-accounted`, { uuids });
  }
}
